/* ===========================================================================
 * ARQUIVO GERADO — não edite aqui.
 *
 * Origem: teams_app_shell/packages/web-shim/teams-native.js
 * Atualize com:  npm run bridge:sync   (no repositório teams_app_shell)
 * =========================================================================== */

/**
 * ADAPTADOR DA PONTE NATIVA — arquivo de origem em
 * teams_app_shell/packages/web-shim/teams-native.js
 *
 * Este arquivo é COPIADO para `src/native/index.js` de cada front
 * (`npm run bridge:sync -- ../salesteams_app_vue`). Edite no template, nunca na
 * cópia: a próxima sincronização sobrescreve.
 *
 * O QUE ELE FAZ
 * Dá ao front uma API estável (`native.isNative`, `native.haptic(...)`, …) que:
 *   - dentro do aplicativo, conversa com `window.TeamsNative`;
 *   - no navegador comum, vira no-op e devolve valores neutros.
 *
 * Com isso, NENHUMA tela do painel precisa saber se está no app ou no site, e o
 * front não ganha nenhuma dependência do Capacitor — o que importa muito aqui,
 * porque o Sales Teams é Vue CLI 4 + webpack 4 e não aceitaria esses pacotes.
 *
 * Sem dependências, sem sintaxe moderna demais (roda no webpack 4 e no Vite).
 */

function ponte() {
  return typeof window !== 'undefined' ? window.TeamsNative : undefined;
}

function noop() {}

function resolvido(valor) {
  return Promise.resolve(valor);
}

var native = {
  /** true somente dentro do aplicativo (Android/iOS). */
  get isNative() {
    var b = ponte();
    return !!(b && b.isNative);
  },

  /** 'android' | 'ios' | 'web' */
  get platform() {
    var b = ponte();
    return b ? b.platform : 'web';
  },

  /** Versão do aplicativo instalada; string vazia no navegador. */
  get appVersion() {
    var b = ponte();
    return b ? b.appVersion : '';
  },

  /**
   * Espera a ponte terminar de subir (restaurar sessão, ler versão etc.).
   * Chame ANTES de montar o front. Tem prazo próprio: se algo travar, o
   * aplicativo abre do mesmo jeito.
   */
  ready: function (timeoutMs) {
    var b = ponte();

    if (!b || typeof b.ready !== 'function') return resolvido(false);

    var limite = new Promise(function (resolve) {
      setTimeout(function () {
        resolve(false);
      }, timeoutMs || 4000);
    });

    return Promise.race([
      b.ready().then(function () {
        return true;
      }),
      limite,
    ]).catch(function () {
      return false;
    });
  },

  /**
   * Diz à ponte como navegar. Use uma vez, logo após criar o router:
   *   native.setNavigator(function (path) { router.push(path).catch(noop) })
   * É por aqui que a notificação tocada leva o usuário à tela certa.
   */
  setNavigator: function (fn) {
    var b = ponte();
    if (b && b.setNavigator) b.setNavigator(fn);
  },

  /** Abre um endereço fora do aplicativo (loja, site institucional, PDF). */
  openExternal: function (url) {
    var b = ponte();

    if (b && b.openExternal) return b.openExternal(url);
    if (typeof window !== 'undefined') window.open(url, '_blank', 'noopener');

    return resolvido(null);
  },

  /** Eventos: 'resume', 'pause', 'online', 'offline'. */
  on: function (evento, cb) {
    var b = ponte();
    if (b && b.on) b.on(evento, cb);
  },

  session: {
    /** Chame depois do login, para o token ir ao armazenamento nativo. */
    mirror: function () {
      var b = ponte();
      return b && b.session ? b.session.mirror() : resolvido(null);
    },
    /** Chame no logout: apaga o espelho nativo junto com o localStorage. */
    clear: function () {
      var b = ponte();
      return b && b.session ? b.session.clear() : resolvido(null);
    },
  },

  push: {
    /** Pede permissão e vincula o aparelho ao usuário logado. */
    register: function () {
      var b = ponte();
      return b && b.push ? b.push.register() : resolvido(null);
    },
    unregister: function () {
      var b = ponte();
      return b && b.push ? b.push.unregister() : resolvido(null);
    },
    /** cb(evento, notificacao) — evento é 'received' ou 'opened'. */
    onNotification: function (cb) {
      var b = ponte();
      if (b && b.push) b.push.onNotification(cb);
    },
    setBadge: function (n) {
      var b = ponte();
      return b && b.push ? b.push.setBadge(n) : resolvido(null);
    },
  },

  camera: {
    /**
     * Abre câmera/galeria nativa. Devolve { dataUrl, format } ou null se a
     * pessoa cancelar. No navegador devolve null — o front deve continuar
     * usando o `input[type=file]` de sempre quando `isNative` é falso.
     */
    pickPhoto: function (opcoes) {
      var b = ponte();
      return b && b.camera ? b.camera.pickPhoto(opcoes || {}) : resolvido(null);
    },
  },

  /** Folha de compartilhamento nativa; no navegador cai na Web Share API. */
  share: function (dados) {
    var b = ponte();

    if (b && b.share) return b.share(dados);

    if (typeof navigator !== 'undefined' && navigator.share) return navigator.share(dados);

    return resolvido(null);
  },

  /** 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' */
  haptic: function (tipo) {
    var b = ponte();
    return b && b.haptic ? b.haptic(tipo || 'light') : resolvido(null);
  },

  network: {
    isOnline: function () {
      var b = ponte();

      if (b && b.network) return b.network.isOnline();
      if (typeof navigator !== 'undefined') return navigator.onLine !== false;

      return true;
    },
  },

  biometric: {
    isAvailable: function () {
      var b = ponte();
      return b && b.biometric ? b.biometric.isAvailable() : resolvido(false);
    },
    lock: function () {
      var b = ponte();
      return b && b.biometric ? b.biometric.lock() : resolvido(null);
    },
  },

  noop: noop,
};

export default native;
export { native };
